import React, { useEffect } from 'react'
import TagManager from 'react-gtm-module'

import PropTypes from 'prop-types'
import { isMobile, isTablet, MobileView, BrowserView } from 'react-device-detect'
import styled from 'styled-components'
import { Layout } from 'core/components/ui'
import { greys } from 'assets/themes/theme-default'
import Header from '../header'
import ErrorBoundary from '../../components/errorBoundary'
import ModalDeletInfo from '../modal-delete-info'

const { Content, Sider } = Layout

const StyledContent = styled(Content)`
  background: ${greys.light4};
  /*background:${props => (props.showSider ? 'red' : 'green')};*/
  /*overflow-x: hidden;*/
  padding: ${props =>
    isMobile ? `70px ${props.showSider ? '70px' : '20px'} 70px 20px` : '64px 0px 90px 0px'};
  width: 100%;
  padding-top:${props => props.paddingtop}px;
`
const StyledSider = styled(Sider)`
  background: 0 none;
`

const ErrorLayout = props => {
  const { children, showSider, configuration } = props
  const { campaign } = configuration

  useEffect(() => {
    if (campaign && campaign.googleAnalyticsId) {
      const tagManagerArgs = {
        gtmId: campaign.googleAnalyticsId
      }
      TagManager.initialize(tagManagerArgs)
    }
  }, [])

  let PanelTheme

  return (
    <Layout type="flex" align="stretch" style={{ height: '100%' }} data-test="component-layout">
      <Header data-test="layout-header" />
      <ErrorBoundary>
        {PanelTheme}
        <MobileView>
          <StyledContent
            data-test="layout-content"
            showSider={showSider}
            paddingtop={
              campaign &&
              campaign.theme &&
              campaign.theme.header &&
              campaign.theme.header.header &&
              campaign.theme.header.header.height
            }
          >
            {children}
          </StyledContent>
        </MobileView>
        {!isTablet && (
          <BrowserView>
            <Layout>
              <StyledContent
                data-test="layout-content"
                paddingtop={
                  campaign &&
                  campaign.theme &&
                  campaign.theme.header &&
                  campaign.theme.header.header &&
                  campaign.theme.header.header.height
                }
              >
                {children}
              </StyledContent>
              {showSider && <StyledSider />}
            </Layout>
          </BrowserView>
        )}
      </ErrorBoundary>
      <ModalDeletInfo />
    </Layout>
  )
}

ErrorLayout.defaultProps = {
  showSider: true
}

ErrorLayout.propTypes = {
  children: PropTypes.node.isRequired,
  showSider: PropTypes.bool,
  configuration: PropTypes.shape().isRequired
}

export default ErrorLayout
